<template>
	<div class="w3-container">
		<div id="id01" class="w3-modal">
			<div class="w3-modal-content">
				<div class="w3-container" style="padding: 10px;">
					<div class="w3-row">
						<div class="w3-col l6 m6 s6 w3-center" style="padding-right: 4px;">
							<div class="w3-card-4 w3-padding" @click="setUploadFile" style="cursor: pointer;">
								<div>
									<img style="max-height: 300px;" class="w3-image" src="assets/images/pdf.png" >
								</div>
								<div>
									Upload SK
								</div>
							</div>
						</div>
						<div class="w3-col l6 m6 s6 w3-center" style="padding-left: 4px;">
							<div class="w3-card-4 w3-padding" @click="loadScan" style="cursor: pointer;">
								<div>
									<img style="max-height: 300px;" class="w3-image" src="assets/images/qrcode.png" >
								</div>
								<div>
									Scan Code
								</div>
							</div>
						</div>
					</div>
					<div class="w3-panel w3-pale-red w3-leftbar w3-border-red">
						<p><b>SiRinduNona Validasi TTE</b></p>
						<p>
							Untuk mengecek apakah file SK valid atau tidak bisa menggunakan salah satu fitur diatas
							<ol>
								<li>
									Upload SK jika file berupa pdf
								</li>
								<li>
									Scan QR Code Jika file berupa hardcopy atau berupa print
								</li>
							</ol>
						</p>
					</div>
				</div>
			</div>
		</div>
		<div id="idPreview" class="w3-modal">
			<div class="w3-modal-content w3-animate-zoom w3-card-4" style="width:90%;margin-top:-50px;">   
				<header class="w3-container w3-theme-d3 drag" style="cursor:move;"> 
					<span onclick="document.getElementById('idPreview').style.display='none'" 
					class="w3-button w3-display-topright">&times;</span>
					<h6><i class="fa fa-windows"></i> Output Validasi</h6>
				</header>
				<div class="w3-container w3-theme-l4 w3-responsive">
					<div class="w3-margin w3-responsive"  v-if="result.jumlah_signature>0">
						<table class="w3-table-all">
							<thead>
								<tr>
									<th class="w3-light-grey" width="200px">Note</th>
									<th class="w3-white">{{result.notes}}</th>
								</tr>
								<tr>
									<th class="w3-light-grey">Summary</th>
									<th class="w3-white">{{result.summary}}</th>
								</tr>

							</thead>
							<tbody v-for="(dtl, index) in result.details" :key="index">
								<tr>
									<td class="w3-blue" colspan="2" style="text-align:center"><b>Info Signer</b></td>
								</tr>
								<tr>
									<td class="w3-light-grey"  width="200px">Signer Name</td>
									<td class="w3-white">{{dtl.info_signer.signer_name}}</td>
								</tr>
								<tr>
									<td class="w3-light-grey">Issuer Dn</td>
									<td class="w3-white">{{dtl.info_signer.issuer_dn}}</td>
								</tr>
								<tr>
									<td class="w3-light-grey">Signer Cert Validity</td>
									<td class="w3-white">{{dtl.info_signer.signer_cert_validity}}</td>
								</tr>
								<tr>
									<td class="w3-light-grey">Signer Dn</td>
									<td class="w3-white">{{dtl.info_signer.signer_dn}}</td>
								</tr>

								<tr>
									<td class="w3-blue" colspan="2" style="text-align:center"><b>Info Document</b></td>
								</tr>
								<tr>
									<td class="w3-light-grey"  width="200px">location</td>
									<td class="w3-white">{{dtl.signature_document.location}}</td>
								</tr>
								<tr>
									<td class="w3-light-grey">Reason</td>
									<td class="w3-white">{{dtl.signature_document.reason}}</td>
								</tr>
							</tbody>
						</table>

					</div>
					<div v-else class="w3-panel w3-pale-red w3-leftbar w3-border-red">
						<p><b>SiRinduNona Validasi TTE</b></p>
						<p>
							Dokumen tidak valid
						</p>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	export default {
		name: "Home",
		components: {},
		data () {
			return {
				result: '',
				error: '',
				detailinfo: {}
			}
		},
	
		methods: {
			selectFile(contentType, multiple) {
				return new Promise(resolve => {
					let input = document.createElement("input");
					input.type = "file";
					input.multiple = multiple;
					input.accept = contentType;
					// eslint-disable-next-line no-unused-vars
					input.onchange = _ => {
						let files = Array.from(input.files);
						if (multiple) {
							resolve(files);
						} else {
							resolve(files.first);
						}
					};
					input.click();
				});
			},
			
			async setUploadFile(){
				let self = this;
				let fileInput = await this.selectFile("application/pdf", true);
				self.showLoading("Proses validasi ..");
				self.apiUpload('/apiadmin/user/validasi',fileInput[0],[],function(json) {
					self.result = json;
					self.hideLoading();
					document.getElementById("idPreview").style.display = "block";
				}, function(err){
					self.hideLoading();
					console.log(err);
				}, function(ld){
					console.log(ld);
				});
			},
			loadScan(){
				this.$router.push('/qrcode');
			}
		},
		mounted(){
			document.getElementById("id01").style.display = "block";
		}
	}	
</script>

<style>
</style>
